import React, { MouseEventHandler } from 'react';
import { getBrand } from 'flow/brands/brands';
import useAppContext from 'flow/hooks/useAppContext';
import BaseModal from '../../ui-components/BaseModal';

interface Props {
    open: boolean;
    handleClose: () => void;
    onLinkClick?: MouseEventHandler<HTMLAnchorElement>;
}

const SignInHelperDialog = ({ open, handleClose, onLinkClick }: Props) => {
    const { i18next } = useAppContext();

    const activateAccountUrl = getBrand().passwordActionUrl
        ? `${getBrand().passwordActionUrl}/signin.jsp?token&activate`
        : null;
    const resetPasswordUrl = getBrand().passwordActionUrl
        ? `${getBrand().passwordActionUrl}/signin.jsp?pwreset`
        : null;

    return (
        <BaseModal
            open={open}
            ariaLabel={i18next.t('signin.helper.help')}
            onClose={handleClose}
            disableActions={true}
            disablePadding={true}
        >
            <div className="flex flex-col gap-6 px-4 pb-6">
                <div className="flex flex-col gap-3 text-sm">
                    <div className="text-base font-bold">
                        {i18next.t('signin.help.new_user')}
                    </div>
                    <div>
                        <a
                            href={activateAccountUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={onLinkClick}
                            className="text-link"
                        >
                            {i18next.t('signin.help.activate_account')}
                        </a>
                        {' ' + i18next.t('signin.help.activate_account.code')}
                    </div>

                    <div>{i18next.t('signin.help.contact_admin')}</div>
                </div>

                <div className="flex flex-col gap-3 text-sm">
                    <div className="text-base font-bold">
                        {i18next.t('signin.username')}
                    </div>
                    <div>{i18next.t('signin.help.info_username')}</div>
                </div>

                <div className="flex flex-col gap-3 text-sm">
                    <div className="text-base font-bold">
                        {i18next.t('signin.password')}
                    </div>
                    <div>
                        {i18next.t('signin.help.info_password')}
                        <a
                            href={resetPasswordUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={onLinkClick}
                            className="text-link"
                        >
                            {' ' + i18next.t('signin.help.info_password_reset')}
                        </a>
                        {'.'}
                    </div>
                </div>
            </div>
        </BaseModal>
    );
};

export default SignInHelperDialog;
